export default __webpack_public_path__ + "static/media/hamburger.50a4f3cf.svg";